module.exports = __webpack_public_path__ + "static/img/bg.87215d43.jpg";